import React from 'react'
import { StyledServiceFeatureDetails } from './styled'
import O_S from 'images/spa/top/service_features/o_s.png'
import E_I from 'images/spa/top/service_features/e_i.png'
import H_K from 'images/spa/top/service_features/h_k.png'
import A_T from 'images/spa/top/service_features/a_t.png'
import { ServiceFeatureDetailsWorker } from './types'

const workers: ServiceFeatureDetailsWorker[] = [
  {
    name: 'O.S',
    occupation: 'バックエンドエンジニア',
    image: O_S,
    steps: [
      { label: '開始', price: 825_000 },
      { label: '更新1回目', price: 920_000 },
      { label: '更新2回目', price: 1_008_000 }
    ],
    percent: 22
  },
  {
    name: 'E.I',
    occupation: 'アプリエンジニア',
    image: E_I,
    steps: [
      { label: '開始', price: 750_000 },
      { label: '更新1回目', price: 800_000 },
      { label: '更新4回目', price: 850_000, jump: true }
    ],
    percent: 13
  },
  {
    name: 'H.K',
    occupation: 'フロントエンドエンジニア',
    image: H_K,
    steps: [
      { label: '開始', price: 750_000 },
      { label: '更新3回目', price: 960_000, jump: true },
    ],
    percent: 28
  },
  {
    name: 'A.T',
    occupation: 'プロダクトマネージャー',
    image: A_T,
    steps: [
      { label: '開始', price: 700_000 },
      { label: '更新2回目', price: 930_000 }
    ],
    percent: 33
  }
]

export const ServiceFeatureDetails: React.FC = () => {
  return <StyledServiceFeatureDetails workers={workers} />
}
